/**
 * Comparator for sorting relative time strings like "5 minutes", "2 hours", "3 days".
 *
 * Compares two relative-time strings by their time unit first (minutes < hours < days
 * < months < years), then by numeric value within the same unit. "just now" is always
 * the most recent. Non-string or empty values sort last.
 *
 * Used by device list sorting to order devices by "last seen" age.
 *
 * Time unit priority (most recent first):
 *   "just now" → "N minutes" → "N hours" → "N days" → "N months" → "N years"
 *
 * @param a - First relative time string (e.g. "5 minutes", "2 hours") or number
 * @param b - Second relative time string or number
 * @returns {number} Negative if a is more recent, positive if b is more recent
 *
 * @example
 * // Sort devices by last seen (most recent first)
 * devices.sort((a, b) => strangeCompare(a.lastSeen, b.lastSeen));
 * // "just now" < "3 minutes" < "1 hours" < "2 days"
 */
export const strangeCompare = (a: string | number, b: string | number): number => {
  if (typeof a !== 'string' || a === '') return 1;
  if (typeof b !== 'string' || b === '') return -1;
  if (a.includes('just now')) return -1;
  if (a.includes(' minutes')) {
    if (b.includes('just now')) return 1;
    if (b.includes(' hours')) return -1;
    if (b.includes(' days')) return -1;
    if (b.includes(' months')) return -1;
    if (b.includes(' years')) return -1;
    if (b === '') return -1;
    a = Number.parseInt(a);
    b = Number.parseInt(b);
  } else if (a.includes(' hours')) {
    if (b.includes('just now')) return 1;
    if (b.includes(' minutes')) return 1;
    if (b.includes(' days')) return -1;
    if (b.includes(' months')) return -1;
    if (b.includes(' years')) return -1;
    if (b === '') return -1;
    a = Number.parseInt(a);
    b = Number.parseInt(b);
  } else if (a.includes(' days')) {
    if (b.includes('just now')) return 1;
    if (b.includes(' minutes')) return 1;
    if (b.includes(' hours')) return 1;
    if (b.includes(' months')) return -1;
    if (b.includes(' years')) return -1;
    if (b === '') return -1;
    a = Number.parseInt(a);
    b = Number.parseInt(b);
  } else if (a.includes(' months')) {
    if (b.includes('just now')) return 1;
    if (b.includes(' minutes')) return 1;
    if (b.includes(' hours')) return 1;
    if (b.includes(' days')) return 1;
    if (b.includes(' years')) return -1;
    if (b === '') return -1;
    a = Number.parseInt(a);
    b = Number.parseInt(b);
  } else if (a.includes(' years')) {
    if (b.includes('just now')) return 1;
    if (b.includes(' minutes')) return 1;
    if (b.includes(' hours')) return 1;
    if (b.includes(' days')) return 1;
    if (b.includes(' months')) return 1;
    if (b === '') return -1;
    a = Number.parseInt(a);
    b = Number.parseInt(b);
  }

  if (Number.isNaN(b)) return -1;

  return a > b ? 1 : -1;
};
